import mori from 'mori';

/**
 * Filter the filtered data (again), to only
 * retain rows (locations) we are interested in
 * @param  {mori.vector} filteredData        [filtered data]
 * @param  {mori.vector} activeLocations     [active locations in footnotes]
 * @return {mori.vector}                     [relevent data]
 */
export default function getRelevantRows(
  filteredData,
  activeLocations,
) {
  return mori.map(
    (sheet) => mori.vector(
      mori.first(sheet),
      mori.filter(
        (item) => mori.some(
          (location) => (
            location === mori.get(item, mori.set(['Location', 'Geography'])) ||
            location === mori.get(item, mori.set(['State', 'Geography']))
          ),
          activeLocations
        ),
        mori.flatten(mori.rest(sheet))
      )
    ),
    filteredData
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getFootnotes/getRelevantRows.js